import { cn } from '@/lib/utils';
import { Button, Loading } from '@music-vine/cadence/ui';
import type { MouseEventHandler } from 'react';
export interface ShowMoreAssetsHomeProps {
  className?: string;
  /** Next page URL. Only crawlers follow it — callers cancel the click. */
  href?: string;
  isFetchingNextPage?: boolean;
  label?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
}
const buttonClassName = 'w-full border border-solid font-semibold text-base shadow-[0px_2px_8px_0px_rgba(21,26,32,0.06)] dark:shadow-[0px_1px_4px_0px_rgba(21,26,32,0.04)]';
export const ShowMoreAssetsHome = ({
  isFetchingNextPage,
  onClick,
  className,
  href,
  label = 'Show more'
}: ShowMoreAssetsHomeProps) => <div className={cn('flex justify-center', className)} data-sentry-component="ShowMoreAssetsHome" data-sentry-source-file="ShowMoreAssetsHome.tsx">
    {href ?
  // Not next/link: the click is always cancelled, so prefetching is waste.
  <Button asChild className={buttonClassName} size="xl" variant="subtle">
        <a href={href} onClick={onClick}>
          <Loading visible={isFetchingNextPage} /> {label}
        </a>
      </Button> : <Button className={buttonClassName} disabled={isFetchingNextPage} onClick={onClick} size="xl" variant="subtle">
        <Loading visible={isFetchingNextPage} /> {label}
      </Button>}
  </div>;